<template>
    <div @click="scrollEvent" class="scrollBtn primary-button">
        Узнать больше
    </div>
</template>

<style scoped lang="scss" src="./style.scss"></style>

<script src="./script.js"></script>